import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/shared/Layout/Layout';
import Button from '../../../components/shared/Button/Button';
import {
  AuthContainer,
  AuthCard,
  AuthTitle,
  AuthSubtitle,
  FormGroup,
  FormLabel,
  FormInput,
  ErrorMessage,
} from '../../../components/shared/Form/Form.styles';
import { peekSessionNotice, clearSessionNotice } from '../../../utils/sessionExpiry';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(() => peekSessionNotice('admin'));
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { clearSessionNotice('admin'); }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await response.json();

      if (result.success) {
        localStorage.setItem('admin-token', result.token);
        localStorage.setItem('admin', JSON.stringify(result.admin));
        navigate('/admin');
      } else {
        setError(result.error || 'Error al iniciar sesión');
      }
    } catch (err) {
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout showHeader={false}>
      <AuthContainer style={{ minHeight: '100vh', alignItems: 'center' }}>
        <AuthCard>
          <div style={{ textAlign: 'center', marginBottom: '8px' }}>
            <a href="/" aria-label="BokerHub, ir al inicio">
              <img
                src="/assets/logos/isotipo-color.png"
                alt="BokerHub"
                style={{ height: '48px' }}
              />
            </a>
          </div>
          <AuthTitle>Administración</AuthTitle>
          <AuthSubtitle>Acceso exclusivo del equipo BokerHub</AuthSubtitle>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel>Email</FormLabel>
              <FormInput
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Contraseña</FormLabel>
              <FormInput
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <Button type="submit" fullWidth disabled={loading}>
              {loading ? 'Verificando...' : 'Entrar'}
            </Button>
          </form>
        </AuthCard>
      </AuthContainer>
    </Layout>
  );
};

export default AdminLogin;
